import { useEffect, useState } from "react";
import client from "@/lib/api";
import { Loader2, ImageOff } from "lucide-react";

// Loads an image from an authenticated API path (Bearer token) as a blob and
// renders it via an object URL. `src` is a path relative to the API base.
export default function AuthedImage({ src, alt = "", className = "", noContext = false }) {
  const [url, setUrl] = useState(null);
  const [state, setState] = useState("loading");

  useEffect(() => {
    let active = true;
    let objectUrl = null;
    setState("loading");
    setUrl(null);
    (async () => {
      try {
        const res = await client.get(src, { responseType: "blob" });
        if (!active) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
        setState("ready");
      } catch {
        if (active) setState("error");
      }
    })();
    return () => {
      active = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [src]);

  if (state === "loading") {
    return <div className={`grid place-items-center bg-slate-100 ${className}`}><Loader2 className="h-5 w-5 animate-spin text-muted-foreground" /></div>;
  }
  if (state === "error") {
    return <div className={`grid place-items-center bg-slate-100 text-muted-foreground ${className}`}><ImageOff className="h-5 w-5" /></div>;
  }
  return (
    <img
      src={url}
      alt={alt}
      draggable={false}
      onDragStart={(e) => e.preventDefault()}
      onContextMenu={noContext ? (e) => e.preventDefault() : undefined}
      className={className}
    />
  );
}
